import { render, staticRenderFns } from "./array-list-view.vue?vue&type=template&id=41b4a5b4&scoped=true"
import script from "./array-list-view.vue?vue&type=script&lang=js"
export * from "./array-list-view.vue?vue&type=script&lang=js"
import style0 from "./array-list-view.vue?vue&type=style&index=0&id=41b4a5b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b4a5b4",
  null
  
)

export default component.exports